import React from "react";
import { Accordion, AccordionSummary, AccordionDetails, Typography, Grid, Button, Box } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { AntSwitch } from "@/components/AntSwitcher";
import { useDispatch, useSelector } from "react-redux";
import { deactivateVASControlDataRequest, fetchVasControlDataRequest, fetchWhatsappChargesRequest, updateVasControlDataRequest, updateVasControlDataReset, updateWhatsappNotificationChargesRequest, } from "@/redux/actions";
import { enqueueSnackbar } from "notistack";
import { VASactivationServicesPayload } from "@/utils/Constants";
const VasControls = () => {
    const dispatch = useDispatch();
    const [expanded, setExpanded] = React.useState(false);
    const [status, setStatus] = React.useState("");
    const [isWhatsAppNotificationChargesActive, setIsWhatsAppNotificationChargesActive] = React.useState(false);
    const [toggleStates, setToggleStates] = React.useState({});
    const [subToggleStates, setSubToggleStates] = React.useState({});
    const getWhatsappChargesState = useSelector((state) => state.getWhatsappChargesReducer);
    const updateWhatsappChargesState = useSelector((state) => state.updateWhatsappNotificationChargesReducer);
    const getVasControlState = useSelector((state) => state.getVasControlDataReducer);
    const updateVasControlState = useSelector((state) => state.updateVasControlDataReducer);
    const [tenantId, setTenantId] = React.useState("");
    const updateTenantId = () => {
        setTenantId(localStorage.getItem("tenantId") || "");
    };
    React.useEffect(() => {
        updateTenantId();
        const handleStorageChange = (event) => {
            if (event.key === "tenantId") {
                updateTenantId();
            }
        };
        window.addEventListener("storage", handleStorageChange);
        const interval = setInterval(updateTenantId, 1000);
        return () => {
            window.removeEventListener("storage", handleStorageChange);
            clearInterval(interval);
        };
    }, []);
    React.useEffect(() => {
        if (tenantId) {
            dispatch(fetchWhatsappChargesRequest({ tenantId, vasService: "whatsapp_tracking", countryCode: "in" }));
            dispatch(fetchVasControlDataRequest({ tenantId }));
        }
    }, [tenantId]);
    React.useEffect(() => {
        if (getWhatsappChargesState.data) {
            const key = "whatsappNotification";
            if (getWhatsappChargesState.data.isActive === true) {
                setToggleStates((prev) => (Object.assign(Object.assign({}, prev), { [key]: !prev[key] })));
                setIsWhatsAppNotificationChargesActive(true);
            }
            else {
                setIsWhatsAppNotificationChargesActive(false);
            }
        }
        else if (getWhatsappChargesState.error) {
            enqueueSnackbar(getWhatsappChargesState.error, { variant: "error" });
        }
    }, [getWhatsappChargesState]);
    React.useEffect(() => {
        if (getVasControlState.data) {
            const key1 = "aiRtoRisk";
            const key2 = "orderWhatsapp";
            const key3 = "orderWhatsappNdr";
            const key4 = "ivrNdr";
            const key5 = "ivrOrder";
            const key6 = "otpVerifiedDelivery";
            const key7 = "addressVerification";
            setToggleStates((prev) => {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
                return Object.assign(Object.assign({}, prev), { [key1]: (_b = (_a = getVasControlState.data) === null || _a === void 0 ? void 0 : _a.riskAssessment) === null || _b === void 0 ? void 0 : _b.enableRiskProfileValidation, [key2]: (_d = (_c = getVasControlState.data) === null || _c === void 0 ? void 0 : _c.addressValidation) === null || _d === void 0 ? void 0 : _d.enableWhatsAppAddressValidation, [key3]: (_f = (_e = getVasControlState.data) === null || _e === void 0 ? void 0 : _e.whatsappNdrVerification) === null || _f === void 0 ? void 0 : _f.enableWhatsappNdrVerification, [key4]: (_h = (_g = getVasControlState.data) === null || _g === void 0 ? void 0 : _g.ivrNdrConfirmation) === null || _h === void 0 ? void 0 : _h.enableIvrNdrConfirmation, [key5]: (_k = (_j = getVasControlState.data) === null || _j === void 0 ? void 0 : _j.ivrOrderConfirmation) === null || _k === void 0 ? void 0 : _k.enableOrderConfirmation, [key6]: (_m = (_l = getVasControlState.data) === null || _l === void 0 ? void 0 : _l.otpBasedBasedDelivery) === null || _m === void 0 ? void 0 : _m.enableOtpBasedDelivery, [key7]: (_p = (_o = getVasControlState.data) === null || _o === void 0 ? void 0 : _o.addressVerification) === null || _p === void 0 ? void 0 : _p.enableAddressVerificationConfig });
            });
        }
        else if (getVasControlState.error) {
            enqueueSnackbar(getVasControlState.error, { variant: "error" });
        }
    }, [getVasControlState]);
    React.useEffect(() => {
        if (updateWhatsappChargesState.data || updateWhatsappChargesState.data === false) {
            enqueueSnackbar("WhatsApp notification config updated successfully", { variant: "success" });
        }
        else if (updateWhatsappChargesState.error) {
            enqueueSnackbar(updateWhatsappChargesState.error, { variant: "error" });
        }
    }, [updateWhatsappChargesState]);
    const handleAccordionChange = (key) => (_, isExpanded) => {
        setExpanded(isExpanded ? key : false);
    };
    const handleMainToggle = (key) => {
        setToggleStates((prev) => {
            const nextValue = !prev[key];
            // Open accordion only if toggled to TRUE
            if (nextValue) {
                setExpanded(key);
            }
            return Object.assign(Object.assign({}, prev), { [key]: nextValue });
        });
    };
    const handleSubToggle = (key, type) => {
        setSubToggleStates((prev) => {
            var _a;
            return (Object.assign(Object.assign({}, prev), { [key]: Object.assign(Object.assign({}, prev[key]), { [type]: !((_a = prev[key]) === null || _a === void 0 ? void 0 : _a[type]) }) }));
        });
    };
    const saveWhatsAppNotificationCharges = () => {
        console.log("toggleStates", toggleStates);
        dispatch(updateWhatsappNotificationChargesRequest({
            tenantId,
            activation: toggleStates.whatsappNotification || false,
            countryCode: "in",
        }));
    };
    const saveVasOrderActivationConfig = (action) => {
        setStatus(action);
        const payload = action === "aiRtoRisk"
            ? {
                tenantId,
                type: VASactivationServicesPayload === null || VASactivationServicesPayload === void 0 ? void 0 : VASactivationServicesPayload.AI_RTO_SCORE,
                apiPayload: {
                    enableRiskProfileValidation: true,
                    properties: {
                        enableCodOrder: true,
                        enablePrepaidOrder: true,
                        enabledOrderSourceAsShopify: true,
                        enabledOrderSourceForEasyEcom: true,
                        enabledOrderSourceForZippyy: true,
                        maxThreshold: "string",
                    },
                },
            }
            : action === "orderWhatsapp"
                ? {
                    tenantId,
                    type: VASactivationServicesPayload === null || VASactivationServicesPayload === void 0 ? void 0 : VASactivationServicesPayload.ORDER_WHATSAPP,
                    apiPayload: {
                        enableWhatsAppAddressValidation: true,
                        properties: {
                            enableCodOrder: true,
                            enablePrepaidOrder: true,
                            enabledOrderSourceAsShopify: true,
                            enabledOrderSourceForEasyEcom: true,
                            enabledOrderSourceForZippyy: true,
                            verificationDelayInMinutes: "string",
                            maxRetry: 0,
                        },
                    },
                }
                : action === "orderWhatsappNdr"
                    ? {
                        tenantId,
                        type: VASactivationServicesPayload === null || VASactivationServicesPayload === void 0 ? void 0 : VASactivationServicesPayload.NDR_WHATSAPP_VERIFICATION,
                        apiPayload: {
                            enableWhatsappNdrVerification: true,
                            properties: {
                                enableCodOrder: true,
                                enablePrepaidOrder: true,
                                enabledOrderSourceForShopify: true,
                                enabledOrderSourceForZippyy: true,
                                enabledOrderSourceForEasyEcom: true,
                            },
                        },
                    }
                    : action === "ivrNdr"
                        ? {
                            tenantId,
                            type: VASactivationServicesPayload === null || VASactivationServicesPayload === void 0 ? void 0 : VASactivationServicesPayload.IVR_NDR,
                            apiPayload: {
                                enableIvrNdrConfirmation: true,
                                properties: {
                                    enableCodOrder: true,
                                    enablePrepaidOrder: true,
                                    enabledOrderSourceAsShopify: true,
                                    enabledOrderSourceForEasyEcom: true,
                                    enabledOrderSourceForZippyy: true,
                                },
                            },
                        }
                        : action === "ivrOrder"
                            ? {
                                tenantId,
                                type: VASactivationServicesPayload === null || VASactivationServicesPayload === void 0 ? void 0 : VASactivationServicesPayload.IVR_ORDER,
                                apiPayload: {
                                    enableOrderConfirmation: true,
                                    properties: {
                                        enableCodOrder: true,
                                        enablePrepaidOrder: true,
                                        enabledOrderSourceAsShopify: true,
                                        enabledOrderSourceForEasyEcom: true,
                                        enabledOrderSourceForZippyy: true,
                                    },
                                },
                            }
                            : action === "otpVerifiedDelivery"
                                ? {
                                    tenantId,
                                    type: VASactivationServicesPayload === null || VASactivationServicesPayload === void 0 ? void 0 : VASactivationServicesPayload.OTP_VERIFIED_DELIVERY,
                                    apiPayload: {
                                        enableOtpBasedCancellation: true,
                                        properties: {
                                            enableCodOrder: true,
                                            enablePrepaidOrder: true,
                                            enabledOrderSourceAsShopify: true,
                                            enabledOrderSourceForEasyEcom: true,
                                            enabledOrderSourceForZippyy: true,
                                            carriers: {
                                                additionalProp1: true,
                                                additionalProp2: true,
                                                additionalProp3: true,
                                            },
                                        },
                                    },
                                }
                                : action === "addressVerification"
                                    ? {
                                        tenantId,
                                        type: VASactivationServicesPayload === null || VASactivationServicesPayload === void 0 ? void 0 : VASactivationServicesPayload.ADDRESS_VERIFICATION,
                                        apiPayload: {
                                            enableAddressVerificationConfig: true,
                                        },
                                    }
                                    : {};
        dispatch(updateVasControlDataRequest({
            tenantId,
            apiPayload: payload === null || payload === void 0 ? void 0 : payload.apiPayload,
            type: payload === null || payload === void 0 ? void 0 : payload.type,
        }));
    };
    const vasOrderDeActivationConfig = (action) => {
        dispatch(deactivateVASControlDataRequest({
            tenantId,
            vasTypes: action === "aiRtoRisk"
                ? "RiskScoreCharge"
                : action === "orderWhatsapp"
                    ? "WhatsappOrderVerificationCharge"
                    : action === "orderWhatsappNdr"
                        ? "WhatsappNDRConfirmationCharge"
                        : action === "ivrNdr"
                            ? "IVRNDRConfirmationCharge"
                            : action === "ivrOrder"
                                ? "IVROrderVerificationCharge"
                                : action === "otpVerifiedDelivery"
                                    ? "OtpBasedDelivery"
                                    : action === "addressVerification"
                                        ? "AddressVerification"
                                        : "",
        }));
    };
    React.useEffect(() => {
        if (updateVasControlState.data) {
            if (status === "aiRtoRisk") {
                enqueueSnackbar("AI RTO Risk config updated successfully", { variant: "success" });
            }
            if (status === "orderWhatsapp") {
                enqueueSnackbar("Order whatsApp config updated successfully", { variant: "success" });
            }
            if (status === "orderWhatsappNdr") {
                enqueueSnackbar("WhatsApp NDR Verification config updated successfully", { variant: "success" });
            }
            if (status === "ivrNdr") {
                enqueueSnackbar("IVR NDR confirmation config updated successfully", { variant: "success" });
            }
            if (status === "ivrOrder") {
                enqueueSnackbar("IVR order verification config updated successfully", { variant: "success" });
            }
            if (status === "otpVerifiedDelivery") {
                enqueueSnackbar("OTP verified delivery config updated successfully", { variant: "success" });
            }
            if (status === "addressVerification") {
                enqueueSnackbar("Address verification config updated successfully", { variant: "success" });
            }
            dispatch(updateVasControlDataReset());
        }
        else if (updateVasControlState.error) {
            enqueueSnackbar(updateVasControlState.error, { variant: "error" });
            dispatch(updateVasControlDataReset());
        }
    }, [updateVasControlState]);
    return (React.createElement(Box, { sx: { p: 2 } },
        React.createElement(Typography, { variant: "h6", gutterBottom: true, mb: 2 }, "VAS controls"),
        React.createElement(Accordion, { expanded: expanded === "aiRtoRisk", onChange: handleAccordionChange("aiRtoRisk"), sx: {
                border: "1px solid #eee",
                mb: 1,
                borderRadius: "8px",
                boxShadow: "none",
                "&::before": { display: "none" },
            } },
            React.createElement(AccordionSummary, { expandIcon: React.createElement(ExpandMoreIcon, null), sx: { px: 2 } },
                React.createElement(Grid, { container: true, alignItems: "center" },
                    React.createElement(Grid, { item: true },
                        React.createElement(Grid, { container: true, alignItems: "center", spacing: 1 },
                            React.createElement(Grid, { item: true },
                                React.createElement(Typography, { fontWeight: 600, fontSize: "16px", sx: { fontFamily: "Poppins" } }, "AI RTO risk score")),
                            React.createElement(Grid, { item: true },
                                React.createElement(AntSwitch, { checked: toggleStates["aiRtoRisk"] || false, onChange: () => handleMainToggle("aiRtoRisk"), color: "error", onClick: (e) => e.stopPropagation(), onFocus: (e) => e.stopPropagation() })))))),
            React.createElement(AccordionDetails, null,
                React.createElement(Grid, { container: true, justifyContent: "flex-start", mt: 2 },
                    React.createElement(Button, { variant: "contained", color: "error", sx: { textTransform: "none", width: 100 }, onClick: () => (toggleStates["aiRtoRisk"] ? saveVasOrderActivationConfig("aiRtoRisk") : vasOrderDeActivationConfig("aiRtoRisk")) }, "Save")))),
        React.createElement(Accordion, { expanded: expanded === "whatsappNotification", onChange: handleAccordionChange("whatsappNotification"), sx: {
                border: "1px solid #eee",
                mb: 1,
                borderRadius: "8px",
                boxShadow: "none",
                "&::before": { display: "none" },
            } },
            React.createElement(AccordionSummary, { expandIcon: React.createElement(ExpandMoreIcon, null), sx: { px: 2 } },
                React.createElement(Grid, { container: true, alignItems: "center" },
                    React.createElement(Grid, { item: true },
                        React.createElement(Grid, { container: true, alignItems: "center", spacing: 1 },
                            React.createElement(Grid, { item: true },
                                React.createElement(Typography, { fontWeight: 600, fontSize: "16px", sx: { fontFamily: "Poppins" } }, "Whatsapp notification charges")),
                            React.createElement(Grid, { item: true },
                                React.createElement(AntSwitch, { checked: toggleStates["whatsappNotification"] || false, onChange: () => handleMainToggle("whatsappNotification"), color: "error", onClick: (e) => e.stopPropagation(), onFocus: (e) => e.stopPropagation() })))))),
            React.createElement(AccordionDetails, null,
                React.createElement(Grid, { container: true, justifyContent: "flex-start", mt: 2 },
                    React.createElement(Button, { variant: "contained", color: "error", sx: { textTransform: "none", width: 100 }, onClick: saveWhatsAppNotificationCharges }, "Save")))),
        React.createElement(Accordion, { expanded: expanded === "orderWhatsapp", onChange: handleAccordionChange("orderWhatsapp"), sx: {
                border: "1px solid #eee",
                mb: 1,
                borderRadius: "8px",
                boxShadow: "none",
                "&::before": { display: "none" },
            } },
            React.createElement(AccordionSummary, { expandIcon: React.createElement(ExpandMoreIcon, null), sx: { px: 2 } },
                React.createElement(Grid, { container: true, alignItems: "center" },
                    React.createElement(Grid, { item: true },
                        React.createElement(Grid, { container: true, alignItems: "center", spacing: 1 },
                            React.createElement(Grid, { item: true },
                                React.createElement(Typography, { fontWeight: 600, fontSize: "16px", sx: { fontFamily: "Poppins" } }, "Order whatsapp confirmation")),
                            React.createElement(Grid, { item: true },
                                React.createElement(AntSwitch, { checked: toggleStates["orderWhatsapp"] || false, onChange: () => handleMainToggle("orderWhatsapp"), color: "error", onClick: (e) => e.stopPropagation(), onFocus: (e) => e.stopPropagation() })))))),
            React.createElement(AccordionDetails, null,
                React.createElement(Grid, { container: true, justifyContent: "flex-start", mt: 2 },
                    React.createElement(Button, { variant: "contained", color: "error", sx: { textTransform: "none", width: 100 }, onClick: () => toggleStates["orderWhatsapp"] ? saveVasOrderActivationConfig("orderWhatsapp") : vasOrderDeActivationConfig("orderWhatsapp") }, "Save")))),
        React.createElement(Accordion, { expanded: expanded === "orderWhatsappNdr", onChange: handleAccordionChange("orderWhatsappNdr"), sx: {
                border: "1px solid #eee",
                mb: 1,
                borderRadius: "8px",
                boxShadow: "none",
                "&::before": { display: "none" },
            } },
            React.createElement(AccordionSummary, { expandIcon: React.createElement(ExpandMoreIcon, null), sx: { px: 2 } },
                React.createElement(Grid, { container: true, alignItems: "center" },
                    React.createElement(Grid, { item: true },
                        React.createElement(Grid, { container: true, alignItems: "center", spacing: 1 },
                            React.createElement(Grid, { item: true },
                                React.createElement(Typography, { fontWeight: 600, fontSize: "16px", sx: { fontFamily: "Poppins" } }, "WhatsApp NDR Verification")),
                            React.createElement(Grid, { item: true },
                                React.createElement(AntSwitch, { checked: toggleStates["orderWhatsappNdr"] || false, onChange: () => handleMainToggle("orderWhatsappNdr"), color: "error", onClick: (e) => e.stopPropagation(), onFocus: (e) => e.stopPropagation() })))))),
            React.createElement(AccordionDetails, null,
                React.createElement(Grid, { container: true, justifyContent: "flex-start", mt: 2 },
                    React.createElement(Button, { variant: "contained", color: "error", sx: { textTransform: "none", width: 100 }, onClick: () => toggleStates["orderWhatsappNdr"] ? saveVasOrderActivationConfig("orderWhatsappNdr") : vasOrderDeActivationConfig("orderWhatsappNdr") }, "Save")))),
        React.createElement(Accordion, { expanded: expanded === "ivrNdr", onChange: handleAccordionChange("ivrNdr"), sx: {
                border: "1px solid #eee",
                mb: 1,
                borderRadius: "8px",
                boxShadow: "none",
                "&::before": { display: "none" },
            } },
            React.createElement(AccordionSummary, { expandIcon: React.createElement(ExpandMoreIcon, null), sx: { px: 2 } },
                React.createElement(Grid, { container: true, alignItems: "center" },
                    React.createElement(Grid, { item: true },
                        React.createElement(Grid, { container: true, alignItems: "center", spacing: 1 },
                            React.createElement(Grid, { item: true },
                                React.createElement(Typography, { fontWeight: 600, fontSize: "16px", sx: { fontFamily: "Poppins" } }, "IVR NDR confirmation")),
                            React.createElement(Grid, { item: true },
                                React.createElement(AntSwitch, { checked: toggleStates["ivrNdr"] || false, onChange: () => handleMainToggle("ivrNdr"), color: "error", onClick: (e) => e.stopPropagation(), onFocus: (e) => e.stopPropagation() })))))),
            React.createElement(AccordionDetails, null,
                React.createElement(Grid, { container: true, justifyContent: "flex-start", mt: 2 },
                    React.createElement(Button, { variant: "contained", color: "error", sx: { textTransform: "none", width: 100 }, onClick: () => (toggleStates["ivrNdr"] ? saveVasOrderActivationConfig("ivrNdr") : vasOrderDeActivationConfig("ivrNdr")) }, "Save")))),
        React.createElement(Accordion, { expanded: expanded === "ivrOrder", onChange: handleAccordionChange("ivrOrder"), sx: {
                border: "1px solid #eee",
                mb: 1,
                borderRadius: "8px",
                boxShadow: "none",
                "&::before": { display: "none" },
            } },
            React.createElement(AccordionSummary, { expandIcon: React.createElement(ExpandMoreIcon, null), sx: { px: 2 } },
                React.createElement(Grid, { container: true, alignItems: "center" },
                    React.createElement(Grid, { item: true },
                        React.createElement(Grid, { container: true, alignItems: "center", spacing: 1 },
                            React.createElement(Grid, { item: true },
                                React.createElement(Typography, { fontWeight: 600, fontSize: "16px", sx: { fontFamily: "Poppins" } }, "IVR order verification")),
                            React.createElement(Grid, { item: true },
                                React.createElement(AntSwitch, { checked: toggleStates["ivrOrder"] || false, onChange: () => handleMainToggle("ivrOrder"), color: "error", onClick: (e) => e.stopPropagation(), onFocus: (e) => e.stopPropagation() })))))),
            React.createElement(AccordionDetails, null,
                React.createElement(Grid, { container: true, justifyContent: "flex-start", mt: 2 },
                    React.createElement(Button, { variant: "contained", color: "error", sx: { textTransform: "none", width: 100 }, onClick: () => (toggleStates["ivrOrder"] ? saveVasOrderActivationConfig("ivrOrder") : vasOrderDeActivationConfig("ivrOrder")) }, "Save")))),
        React.createElement(Accordion, { expanded: expanded === "otpVerifiedDelivery", onChange: handleAccordionChange("otpVerifiedDelivery"), sx: {
                border: "1px solid #eee",
                mb: 1,
                borderRadius: "8px",
                boxShadow: "none",
                "&::before": { display: "none" },
            } },
            React.createElement(AccordionSummary, { expandIcon: React.createElement(ExpandMoreIcon, null), sx: { px: 2 } },
                React.createElement(Grid, { container: true, alignItems: "center" },
                    React.createElement(Grid, { item: true },
                        React.createElement(Grid, { container: true, alignItems: "center", spacing: 1 },
                            React.createElement(Grid, { item: true },
                                React.createElement(Typography, { fontWeight: 600, fontSize: "16px", sx: { fontFamily: "Poppins" } }, "OTP verified delivery")),
                            React.createElement(Grid, { item: true },
                                React.createElement(AntSwitch, { checked: toggleStates["otpVerifiedDelivery"] || false, onChange: () => handleMainToggle("otpVerifiedDelivery"), color: "error", onClick: (e) => e.stopPropagation(), onFocus: (e) => e.stopPropagation() })))))),
            React.createElement(AccordionDetails, null,
                React.createElement(Grid, { container: true, justifyContent: "flex-start", mt: 2 },
                    React.createElement(Button, { variant: "contained", color: "error", sx: { textTransform: "none", width: 100 }, onClick: () => toggleStates["otpVerifiedDelivery"]
                            ? saveVasOrderActivationConfig("otpVerifiedDelivery")
                            : vasOrderDeActivationConfig("otpVerifiedDelivery") }, "Save")))),
        React.createElement(Accordion, { expanded: expanded === "addressVerification", onChange: handleAccordionChange("addressVerification"), sx: {
                border: "1px solid #eee",
                mb: 1,
                borderRadius: "8px",
                boxShadow: "none",
                "&::before": { display: "none" },
            } },
            React.createElement(AccordionSummary, { expandIcon: React.createElement(ExpandMoreIcon, null), sx: { px: 2 } },
                React.createElement(Grid, { container: true, alignItems: "center" },
                    React.createElement(Grid, { item: true },
                        React.createElement(Grid, { container: true, alignItems: "center", spacing: 1 },
                            React.createElement(Grid, { item: true },
                                React.createElement(Typography, { fontWeight: 600, fontSize: "16px", sx: { fontFamily: "Poppins" } }, "Address verification")),
                            React.createElement(Grid, { item: true },
                                React.createElement(AntSwitch, { checked: toggleStates["addressVerification"] || false, onChange: () => handleMainToggle("addressVerification"), color: "error", onClick: (e) => e.stopPropagation(), onFocus: (e) => e.stopPropagation() })))))),
            React.createElement(AccordionDetails, null,
                React.createElement(Grid, { container: true, justifyContent: "flex-start", mt: 2 },
                    React.createElement(Button, { variant: "contained", color: "error", sx: { textTransform: "none", width: 100 }, onClick: () => toggleStates["addressVerification"]
                            ? saveVasOrderActivationConfig("addressVerification")
                            : vasOrderDeActivationConfig("addressVerification") }, "Save"))))));
};
export default VasControls;
